import { buildAuthenticatedHeaders } from '@shared/utils/apiHelpers'

export const refresh = async (token: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}auth/token`, {
    method: 'get',
    headers: buildAuthenticatedHeaders(token),
  })
}

export const fetchAuthToken = async (token: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}auth/auth_token`, {
    method: 'get',
    headers: buildAuthenticatedHeaders(token),
  })
}

export const whoAmI = async (token: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}auth/who_am_i`, {
    method: 'get',
    headers: buildAuthenticatedHeaders(token),
  })
}

export const changePassword = async (token: string, payload: object) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}auth/change_password`, {
    method: 'post',
    headers: buildAuthenticatedHeaders(token),
    body: JSON.stringify(payload),
  })
}
